'use client'

import {
  createContext,
  useContext,
  useState,
  useSyncExternalStore,
} from 'react'

import type { ReactNode } from 'react'

const AppNowContext = createContext<number | null>(null)

/** 서버·hydration은 initialNow로 맞추고, 이후에는 이 시계의 현재 시각을 분 단위로 읽는다. */
function createClock() {
  let now = Date.now()
  return {
    read: () => now,
    subscribe: (onChange: () => void) => {
      now = Date.now()
      const timer = setInterval(() => {
        now = Date.now()
        onChange()
      }, 60_000)
      return () => clearInterval(timer)
    },
  }
}

export function AppNowProvider({
  initialNow,
  children,
}: {
  initialNow: number
  children: ReactNode
}) {
  const [clock] = useState(createClock)
  const now = useSyncExternalStore(
    clock.subscribe,
    clock.read,
    () => initialNow
  )
  return <AppNowContext.Provider value={now}>{children}</AppNowContext.Provider>
}

export function useAppNow(): number {
  const now = useContext(AppNowContext)
  if (now === null) throw new Error('AppNowProvider가 필요합니다.')
  return now
}
